import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './CategoriasData.css';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewSeccion from '../NewSeccion/NewSeccion';
import NewCategoria from '../NewCategoria/NewCategoria';
import NewSubCategoria from '../NewSubCategoria/NewSubCategoria';

export default function CategoriasData() {
    const [secciones, setSecciones] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [subcategorias, setSubCategorias] = useState([]);
    const [modalSeccionVisible, setModalSeccionVisible] = useState(false);
    const [modalCategoriaVisible, setModalCategoriaVisible] = useState(false);
    const [modalSubCategoriaVisible, setModalSubCategoriaVisible] = useState(false);
    const [nuevaSeccion, setNuevaSeccion] = useState('');
    const [seccion, setSeccion] = useState({});
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [categoria, setCategoria] = useState({});
    const [nuevaSubCategoria, setNuevaSubCategoria] = useState('');
    const [subcategoria, setSubCategoria] = useState({});
    const [idSeccionCategoria, setIdSeccionCategoria] = useState('');
    const [idCategoriaSubCategoria, setIdCategoriaSubCategoria] = useState('');

    useEffect(() => {
        cargarSecciones();
        cargarCategoria();
        cargarSubCategoria();
    }, []);

    const sameId = (a, b) => String(a ?? '') === String(b ?? '');

    const cargarSecciones = () => {
        fetch(`${baseURL}/seccionesGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const seccionesOrdenadas = (data.secciones || []).sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0));
                setSecciones(seccionesOrdenadas);
            })
            .catch(error => console.error('Error al cargar secciones:', error));
    };

    const cargarSubCategoria = () => {
        fetch(`${baseURL}/subCategoriaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSubCategorias(data.subcategorias || []);
            })
            .catch(error => console.error('Error al cargar subcategorias:', error));
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const categoriasOrdenadas = (data.categorias || []).sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0));
                setCategorias(categoriasOrdenadas);
            })
            .catch(error => console.error('Error al cargar categorias:', error));
    };

    const recargarCatalogo = () => {
        cargarSecciones();
        cargarCategoria();
        cargarSubCategoria();
    };

    const abrirModalSeccion = (item) => {
        setSeccion(item);
        setNuevaSeccion(item.seccion);
        setModalSeccionVisible(true);
    };

    const abrirModalCategoria = (item) => {
        setCategoria(item);
        setNuevaCategoria(item.categoria);
        setIdSeccionCategoria(item.idSeccion || '');
        setModalCategoriaVisible(true);
    };

    const abrirModalSubCategoria = (item) => {
        setSubCategoria(item);
        setNuevaSubCategoria(item.subcategoria);
        setIdCategoriaSubCategoria(item.idCategoria || '');
        setModalSubCategoriaVisible(true);
    };

    const cambiarOrdenSeccion = (idSeccion1, idSeccion2, nuevoOrden1, nuevoOrden2) => {
        fetch(`${baseURL}/seccionesOrdenPut.php`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idSeccion1,
                idSeccion2,
                nuevoOrden1,
                nuevoOrden2
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                } else {
                    cargarSecciones();
                }
            })
            .catch(error => console.error('Error al cambiar el orden:', error));
    };

    const cambiarOrdenCategoria = (idCategoria1, idCategoria2, nuevoOrden1, nuevoOrden2) => {
        fetch(`${baseURL}/categoriasOrdenPut.php`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idCategoria1,
                idCategoria2,
                nuevoOrden1,
                nuevoOrden2
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                } else {
                    cargarCategoria();
                }
            })
            .catch(error => console.error('Error al cambiar el orden:', error));
    };

    const moverSeccionArriba = (index) => {
        if (index === 0) return;
        const seccionActual = secciones[index];
        const seccionAnterior = secciones[index - 1];
        cambiarOrdenSeccion(seccionActual.idSeccion, seccionAnterior.idSeccion, seccionAnterior.orden, seccionActual.orden);
    };

    const moverSeccionAbajo = (index) => {
        if (index === secciones.length - 1) return;
        const seccionActual = secciones[index];
        const seccionSiguiente = secciones[index + 1];
        cambiarOrdenSeccion(seccionActual.idSeccion, seccionSiguiente.idSeccion, seccionSiguiente.orden, seccionActual.orden);
    };

    const moverCategoriaArriba = (categoriasDeSeccion, index) => {
        if (index === 0) return;
        const categoriaActual = categoriasDeSeccion[index];
        const categoriaAnterior = categoriasDeSeccion[index - 1];
        cambiarOrdenCategoria(categoriaActual.idCategoria, categoriaAnterior.idCategoria, categoriaAnterior.orden, categoriaActual.orden);
    };

    const moverCategoriaAbajo = (categoriasDeSeccion, index) => {
        if (index === categoriasDeSeccion.length - 1) return;
        const categoriaActual = categoriasDeSeccion[index];
        const categoriaSiguiente = categoriasDeSeccion[index + 1];
        cambiarOrdenCategoria(categoriaActual.idCategoria, categoriaSiguiente.idCategoria, categoriaSiguiente.orden, categoriaActual.orden);
    };

    const eliminarSeccion = (idSeccion) => {
        Swal.fire({
            title: 'Estas seguro?',
            text: 'No podras revertir esto.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7c3aed',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/seccionDelete.php?idSeccion=${idSeccion}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('Eliminado', data.mensaje, 'success');
                            recargarCatalogo();
                        }
                    })
                    .catch(error => {
                        console.error('Error al eliminar seccion:', error);
                        Swal.fire('Error', 'Ocurrio un problema al eliminar la seccion.', 'error');
                    });
            }
        });
    };

    const eliminarCategoria = (idCategoria) => {
        Swal.fire({
            title: 'Estas seguro?',
            text: 'No podras revertir esto.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7c3aed',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/categoriaDelete.php?idCategoria=${idCategoria}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('Eliminado', data.mensaje, 'success');
                            recargarCatalogo();
                        }
                    })
                    .catch(error => {
                        console.error('Error al eliminar categoria:', error);
                        Swal.fire('Error', 'Ocurrio un problema al eliminar la categoria.', 'error');
                    });
            }
        });
    };

    const eliminarSubcategoria = (idSubCategoria) => {
        Swal.fire({
            title: 'Estas seguro?',
            text: 'No podras revertir esto.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7c3aed',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/subCategoriaDelete.php?idSubCategoria=${idSubCategoria}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('Eliminado', data.mensaje, 'success');
                            cargarSubCategoria();
                        }
                    })
                    .catch(error => {
                        console.error('Error al eliminar subcategoria:', error);
                        Swal.fire('Error', 'Ocurrio un problema al eliminar la subcategoria.', 'error');
                    });
            }
        });
    };

    const handleUpdateSeccion = (idSeccion) => {
        fetch(`${baseURL}/seccionPut.php?idSeccion=${idSeccion}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ seccion: nuevaSeccion || seccion.seccion }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Editado', data.mensaje, 'success');
                    recargarCatalogo();
                    setModalSeccionVisible(false);
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleUpdateCategoria = (idCategoria) => {
        fetch(`${baseURL}/categoriaPut.php?idCategoria=${idCategoria}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                categoria: nuevaCategoria || categoria.categoria,
                idSeccion: idSeccionCategoria || categoria.idSeccion,
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Editado', data.mensaje, 'success');
                    recargarCatalogo();
                    setModalCategoriaVisible(false);
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleUpdateSubCategoria = (idSubCategoria) => {
        fetch(`${baseURL}/subCategoriaPut.php?idSubCategoria=${idSubCategoria}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                subcategoria: nuevaSubCategoria || subcategoria.subcategoria,
                idCategoria: idCategoriaSubCategoria || subcategoria.idCategoria,
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Editado', data.mensaje, 'success');
                    recargarCatalogo();
                    setModalSubCategoriaVisible(false);
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    return (
        <div>
            <ToastContainer />
            <div className='deFlexContentBtns'>
                <NewSeccion />
                <NewCategoria />
                <NewSubCategoria />
            </div>

            {modalSeccionVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Editar Seccion</button>
                            <span className="close" onClick={() => setModalSeccionVisible(false)}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Seccion</legend>
                                    <input
                                        type="text"
                                        value={nuevaSeccion}
                                        onChange={(e) => setNuevaSeccion(e.target.value)}
                                    />
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={() => handleUpdateSeccion(seccion.idSeccion)}>Guardar</button>
                        </div>
                    </div>
                </div>
            )}

            {modalCategoriaVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Editar Categoria</button>
                            <span className="close" onClick={() => setModalCategoriaVisible(false)}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Seccion</legend>
                                    <select value={idSeccionCategoria} onChange={(e) => setIdSeccionCategoria(e.target.value)}>
                                        <option value="">Selecciona una seccion</option>
                                        {secciones.map(item => (
                                            <option key={item.idSeccion} value={item.idSeccion}>{item.seccion}</option>
                                        ))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Categoria</legend>
                                    <input
                                        type="text"
                                        value={nuevaCategoria}
                                        onChange={(e) => setNuevaCategoria(e.target.value)}
                                    />
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={() => handleUpdateCategoria(categoria.idCategoria)}>Guardar</button>
                        </div>
                    </div>
                </div>
            )}

            {modalSubCategoriaVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Editar Subcategoria</button>
                            <span className="close" onClick={() => setModalSubCategoriaVisible(false)}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Categoria</legend>
                                    <select value={idCategoriaSubCategoria} onChange={(e) => setIdCategoriaSubCategoria(e.target.value)}>
                                        <option value="">Selecciona una categoria</option>
                                        {categorias.map(item => (
                                            <option key={item.idCategoria} value={item.idCategoria}>
                                                {item.seccion ? `${item.seccion} > ` : ''}{item.categoria}
                                            </option>
                                        ))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Subcategoria</legend>
                                    <input
                                        type="text"
                                        value={nuevaSubCategoria}
                                        onChange={(e) => setNuevaSubCategoria(e.target.value)}
                                    />
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={() => handleUpdateSubCategoria(subcategoria.idSubCategoria)}>Guardar</button>
                        </div>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <div className='table catalogoTree'>
                    {secciones?.map((itemSeccion, seccionIndex) => {
                        const categoriasDeSeccion = categorias
                            ?.filter(itemCategoria => sameId(itemCategoria.idSeccion, itemSeccion.idSeccion))
                            ?.sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0));

                        return (
                            <div key={itemSeccion.idSeccion} className='seccionBlock'>
                                <div className='CategoriConten seccionContent'>
                                    <div>
                                        <strong>{itemSeccion.orden}- {itemSeccion.seccion}</strong>
                                        <span>{categoriasDeSeccion.length} categorias</span>
                                    </div>
                                    <div className='tdFlex'>
                                        {seccionIndex > 0 && (
                                            <button onClick={() => moverSeccionArriba(seccionIndex)} className='btnCategori'>
                                                <FontAwesomeIcon icon={faChevronUp} />
                                            </button>
                                        )}
                                        {seccionIndex < secciones.length - 1 && (
                                            <button onClick={() => moverSeccionAbajo(seccionIndex)} className='btnCategori'>
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </button>
                                        )}
                                        <button className='eliminar' onClick={() => eliminarSeccion(itemSeccion.idSeccion)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                        <button className='editar' onClick={() => abrirModalSeccion(itemSeccion)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                    </div>
                                </div>

                                <div className='categoriaList'>
                                    {categoriasDeSeccion?.map((itemCategoria, categoriaIndex) => (
                                        <div key={itemCategoria.idCategoria} className='categoriaBlock'>
                                            <div className='CategoriConten categoriaContent'>
                                                <div>
                                                    <strong>{itemCategoria.orden}- {itemCategoria.categoria}</strong>
                                                    <span>Categoria</span>
                                                </div>
                                                <div className='tdFlex'>
                                                    {categoriaIndex > 0 && (
                                                        <button onClick={() => moverCategoriaArriba(categoriasDeSeccion, categoriaIndex)} className='btnCategori'>
                                                            <FontAwesomeIcon icon={faChevronUp} />
                                                        </button>
                                                    )}
                                                    {categoriaIndex < categoriasDeSeccion.length - 1 && (
                                                        <button onClick={() => moverCategoriaAbajo(categoriasDeSeccion, categoriaIndex)} className='btnCategori'>
                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                        </button>
                                                    )}
                                                    <button className='eliminar' onClick={() => eliminarCategoria(itemCategoria.idCategoria)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                    <button className='editar' onClick={() => abrirModalCategoria(itemCategoria)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                </div>
                                            </div>

                                            <div className='subCategori'>
                                                {subcategorias
                                                    ?.filter(itemSubcategoria => sameId(itemSubcategoria.idCategoria, itemCategoria.idCategoria))
                                                    ?.map(itemSubcategoria => (
                                                        <div key={itemSubcategoria.idSubCategoria} className='CategoriConten subcategoriaContent'>
                                                            <div>
                                                                <span>- {itemSubcategoria.subcategoria}</span>
                                                            </div>
                                                            <div>
                                                                <button className='eliminar' onClick={() => eliminarSubcategoria(itemSubcategoria.idSubCategoria)}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                                <button className='editar' onClick={() => abrirModalSubCategoria(itemSubcategoria)}>
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
